<!-- Section: Operacional -->
<div class="section-card" *ngIf="voyage">
    <div class="section-header">
        <mat-icon>tune</mat-icon>
        Datos Operacionales
    </div>

    <div class="section-body">
        <div class="info-grid info-grid-operational">
            <div class="info-item">
                <label>Naviera</label>
                <span>{{ voyage.carrierName || '—' }}</span>
            </div>
            <div class="info-item">
                <label>Emisor B/L</label>
                <span>{{ emisorBl }}</span>
            </div>
            <div class="info-item">
                <label>Terminal</label>
                <span>{{ voyage.terminalPol || '—' }}</span>
                <span
                    class="badge-unavailable"
                    *ngIf="!voyage.isTerminalAvailable"
                    >No disponible</span
                >
            </div>
            <div class="info-item">
                <label>Días en tránsito</label>
                <span>{{ transitDaysDisplay }}</span>
            </div>
            <div class="info-item">
                <label>Embarque</label>
                <span>{{ voyage.portOfLoadingName || '—' }}</span>
            </div>
            <div class="info-item">
                <label>Descarga</label>
                <span>{{ voyage.portOfDischargeName || '—' }}</span>
            </div>
            <div class="info-item">
                <label>País destino final (según POD)</label>
                <span>{{ voyage.countryOfFinalDestination || '—' }}</span>
            </div>
        </div>
    </div>
</div>

<!-- Section: Stacking — solo texto descriptivo del horario -->
<div class="section-card" *ngIf="voyage">
    <div class="section-header">
        <mat-icon>layers</mat-icon>
        Stacking
    </div>
    <div class="section-body section-body-stacking-only">
        <p class="stacking-text">{{ stackingLine }}</p>
    </div>
</div>

<!-- Warning: campos sin datos -->
<div
    class="alert-banner alert-warning"
    *ngIf="voyage && (!voyage.isTerminalAvailable || !voyage.isCutOffAvailable)"
>
    <mat-icon>warning_amber</mat-icon>
    <span
        >Algunos datos operacionales no están disponibles para este viaje.
        Podrán completarse manualmente en los pasos siguientes.</span
    >
</div>

<!-- Info: campos de solo lectura -->
<div class="alert-banner alert-info">
    <mat-icon>info_outline</mat-icon>
    <span
        >Los datos del viaje provienen del itinerario y no pueden modificarse
        desde este formulario.</span
    >
</div>
